import type { Contact, Company, Deal, Activity, Stats } from "./types";

async function request<T>(url: string, options?: RequestInit): Promise<T> {
	const res = await fetch(url, {
		headers: { "Content-Type": "application/json" },
		...options,
	});
	if (res.status === 204) return undefined as T;
	if (!res.ok) throw new Error(`API error: ${res.status}`);
	return res.json();
}

export const api = {
	stats: () => request<Stats>("/api/stats"),

	contacts: {
		list: () => request<Contact[]>("/api/contacts"),
		get: (id: string) => request<Contact>(`/api/contacts/${id}`),
		create: (data: Partial<Contact>) =>
			request<Contact>("/api/contacts", { method: "POST", body: JSON.stringify(data) }),
		update: (id: string, data: Partial<Contact>) =>
			request<Contact>(`/api/contacts/${id}`, { method: "PUT", body: JSON.stringify(data) }),
		delete: (id: string) =>
			request<void>(`/api/contacts/${id}`, { method: "DELETE" }),
	},

	companies: {
		list: () => request<Company[]>("/api/companies"),
		get: (id: string) => request<Company>(`/api/companies/${id}`),
		create: (data: Partial<Company>) =>
			request<Company>("/api/companies", { method: "POST", body: JSON.stringify(data) }),
		update: (id: string, data: Partial<Company>) =>
			request<Company>(`/api/companies/${id}`, { method: "PUT", body: JSON.stringify(data) }),
		delete: (id: string) =>
			request<void>(`/api/companies/${id}`, { method: "DELETE" }),
	},

	deals: {
		list: () => request<Deal[]>("/api/deals"),
		get: (id: string) => request<Deal>(`/api/deals/${id}`),
		create: (data: Partial<Deal>) =>
			request<Deal>("/api/deals", { method: "POST", body: JSON.stringify(data) }),
		update: (id: string, data: Partial<Deal>) =>
			request<Deal>(`/api/deals/${id}`, { method: "PUT", body: JSON.stringify(data) }),
		delete: (id: string) =>
			request<void>(`/api/deals/${id}`, { method: "DELETE" }),
	},

	activities: {
		list: () => request<Activity[]>("/api/activities"),
		get: (id: string) => request<Activity>(`/api/activities/${id}`),
		create: (data: Partial<Activity>) =>
			request<Activity>("/api/activities", { method: "POST", body: JSON.stringify(data) }),
		update: (id: string, data: Partial<Activity>) =>
			request<Activity>(`/api/activities/${id}`, { method: "PUT", body: JSON.stringify(data) }),
		delete: (id: string) =>
			request<void>(`/api/activities/${id}`, { method: "DELETE" }),
	},
};
